<template>
    <el-dialog title="BPM审批情况" :visible.sync="isSwitch" width="1200px" append-to-body :before-close="setSwitchClose">
        <div>
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="SequenceNO" label="流水号" width="250"></el-table-column>
                <el-table-column prop="ApprovalPeople" label="审核人" width="150"></el-table-column>
                <el-table-column prop="FinishTime" label="审批时间" width="200">
                     <template slot-scope="scope">
                        <!-- <span v-if="(scope.row.Status== '已审批')"></span> -->
                        {{scope.row.FinishTime }}
                    </template>
                </el-table-column>
                <el-table-column prop="Status" label="审批状态" width="150"></el-table-column>
                <el-table-column prop="Remark" label="审批意见"></el-table-column>
            </el-table>
        </div>

        <div slot="footer" style="text-align: center">
            <el-button type="primary" @click="setSwitchClose">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        isSwitch: {
            type: Boolean,
            default: false
        },
        id: {
            type: [String, Number],
            default: ''
        }
    },
    watch: {
        isSwitch(newval, oldval) {
            if (newval && this.id) {
                this.initData();
            }
        },
        id(newval, oldval) {
            if (newval && this.isSwitch) {
                this.initData();
            }
        }
    },
    data() {
        return {
            tableData: []
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        setSwitchClose() {
            this.$emit('setSwitchClose');
        },
        async initData() {
            let result = await this.$newsApi.contract.GetBPMWorkflowProcessList({
                BPMBizObjectID: this.id
            });
            this.tableData = result.data.data;
        }
    }
};
</script>
